export const NotificationType = {
  POST_TO_GROUP: 'POST_TO_GROUP',
  REPLY_TO_ACTION: 'REPLY_TO_ACTION',
  REPLY_TO_POST: 'REPLY_TO_POST',
  REPLY_TO_THREAD: 'REPLY_TO_THREAD',
  REACT_TO_ACTION: 'REACT_TO_ACTION',
  REACT_TO_POST: 'REACT_TO_POST',
  REACT_TO_REPLY: 'REACT_TO_REPLY',
};
